<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="view-lib">
    <div class="has-side-bars">
      <div class="title-wrap">
        <h3>{{ $t('view_lib') }}</h3>
        <FilterSort type="fav-list" @toggle-data-loading="toggleDataLoading" />
      </div>
      <ChartCaruselBlock v-if="thesaurus" :thesaurus="thesaurus" type="views-list" />
    </div>
  </div>
</template>

<script>
import FilterSort from '../search/FilterSort.vue'
import ChartCaruselBlock from '../cover/ChartCaruselBlock.vue'
import { getThesaurus } from '@/services/api'

export default {
  components: { FilterSort, ChartCaruselBlock },
  props: {},
  data() {
    return {
      dataLoading: false,
    }
  },
  computed: {},
  asyncComputed: {
    thesaurus() {
      return getThesaurus(this.$store.state.i18n.lang)
    },
  },
  watch: {},
  methods: {
    /**
     * Toggle loading to on/off
     * @public This is a public method
     * @param {String} val not required value that wants to set
     */
     toggleDataLoading: function (val) {
      this.dataLoading = val !== undefined ? val : !this.dataLoading
      let queryPartial = { ...this.$route.query }
      delete queryPartial.page
      this.$router.push({ name: 'Profile', params: { params: this.$route.params.params, optype: this.$route.params.optype }, query: queryPartial })
    },
  },
}
</script>

<style lang="stylus" scoped>
.view-lib
  padding-top: vw(30px)
  padding-bottom: vw(50px)
  background-color: $very-light-grey

  .title-wrap
    display: flex
    justify-content: space-between
    width: 100%

    .mobile &
      flex-direction: column
      gap: vw(20px)

    h3
      margin-block-start: 0
      margin-block-end: 0
      m-font-size(24, 28)
      font-weight: 400
</style>